import { render, staticRenderFns } from "./EditVPage.vue?vue&type=template&id=22fe2b5b&"
import script from "./EditVPage.vue?vue&type=script&lang=js&"
export * from "./EditVPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports